mantissaLength